import { render, staticRenderFns } from "./ToolsProcessor.vue?vue&type=template&id=4492a30b"
import script from "./ToolsProcessor.vue?vue&type=script&lang=js"
export * from "./ToolsProcessor.vue?vue&type=script&lang=js"
import style0 from "./ToolsProcessor.vue?vue&type=style&index=0&id=4492a30b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports